<script lang="ts">
  import editIcon from "./assets/edit.svg?raw";
  import { stopPropagation } from "./genericHandlers";
  import { MAX_SOUND_NAME_LENGTH, showToastWrapper } from "./global";
    import { outclick } from "./lib/interactions";

  export let card;
  export let nameChangeCallback: (newName: string) => void;

  const isNameTooLong = () => {
    return nameInput.value.length > MAX_SOUND_NAME_LENGTH;
  };

  let editing = false;
  let nameInput;
  const handleNameChangeRequest = (event) => {
    if (isNameTooLong()) {
      showToastWrapper(
        "The name selected is too long, please choose a shorter one.",
        true,
      );
      event.preventDefault();
      return;
    }

    nameChangeCallback(nameInput.value);
    editing = false;
  };
  const startEditing = () => {
    editing = true;
  };

  const DOUBLE_CLICK_INTERVAL_MS = 500;
  let nextClickIsADoubleClick = false;
  function handlePointerDown(evt) {
    if (nextClickIsADoubleClick) {
      stopPropagation(evt);
      startEditing();
      return;
    }

    // Do not stop propagation if it's the first click.
    nextClickIsADoubleClick = true;
    setTimeout(
      () => (nextClickIsADoubleClick = false),
      DOUBLE_CLICK_INTERVAL_MS,
    );
  }
</script>

{#if editing}
  <form on:submit={handleNameChangeRequest}>
    <input
      bind:this={nameInput}
      type="text"
      name="sound-name"
      value={card.name}
      class="soundboard-sound-title-input"
      on:pointerdown={stopPropagation}
      on:mousedown={stopPropagation}
      use:outclick={handleNameChangeRequest}
    />
  </form>
{:else}
  <div
    tabindex="0"
    on:dblclick={startEditing}
    on:pointerdown={handlePointerDown}
      on:mousedown={stopPropagation}
  >
    <p class="soundcard-title editable-icon">
      {card["name"]}
      <!-- svelte-ignore a11y-click-events-have-key-events -->
      <span
        class="hover-target"
        tabindex="0"
        on:click={startEditing}
        on:pointerdown={stopPropagation}
      on:mousedown={stopPropagation}
      >
        {@html editIcon}
      </span>
    </p>
  </div>
{/if}
